const LEGACY_COLUMN_TYPES = {
  date: { label: "Date", type: "date" },
  customerNk: { label: "Customer NK", type: "category" },
  toLocation: { label: "Destination Location", type: "category" },
  zone: { label: "Carrier Zone", type: "category" },
  fromCompanyLocation: { label: "From Company Location", type: "category" },
  toCompanyLocation: { label: "To Company Location", type: "category" },
  consignments: { label: "Consignments", type: "number", unit: "count" },
  sell: { label: "Sell", type: "number", unit: "$" },
  cost: { label: "Cost", type: "number", unit: "$" },
  margin: { label: "Margin", type: "number", unit: "$" },
  weight: { label: "Weight (kg)", type: "number", unit: "kg" },
  volume: { label: "Volume", type: "number", unit: "m3" },
  cubic: { label: "Cubic", type: "number", unit: "m3" },
  onTimeRate: { label: "On-time %", type: "number", unit: "%" },
  avgTransit: { label: "Avg Transit (days)", type: "number", unit: "days" },
  minTransit: { label: "Transit Min (days)", type: "number", unit: "days" },
  maxTransit: { label: "Transit Max (days)", type: "number", unit: "days" },
  active: { label: "Active", type: "number", unit: "count" },
  completed: { label: "Completed", type: "number", unit: "count" },
  closed: { label: "Closed", type: "number", unit: "count" },
  partialDelivery: { label: "Partial Delivery", type: "number", unit: "count" },
  trackingExpired: { label: "Tracking Expired", type: "number", unit: "count" },
  effectiveFrom: { label: "Effective From Date", type: "date" },
  tradingStart: { label: "Trading Start Date", type: "date" },
  loadDatetime: { label: "Load Datetime", type: "date" },
  customerName: { label: "Customer Name", type: "category" },
  parentCustomerNk: { label: "Parent Customer NK", type: "category" },
  parentCustomerName: { label: "Parent Customer Name", type: "category" },
  ultimateParentCustomerName: {
    label: "Ultimate Parent Customer Name",
    type: "category",
  },
  stateCode: { label: "State Code", type: "category" },
  stateName: { label: "State", type: "category" },
  suburb: { label: "Suburb", type: "category" },
  postcode: { label: "Postcode", type: "category" },
  isActive: { label: "Active", type: "number" },
  isDisabled: { label: "Disabled", type: "number" },
  carrierAbbreviation: { label: "Abbreviation", type: "category" },
  carrierName: { label: "CARRIER_NAME", type: "category" },
};

const normalizeKey = (value) =>
  value
    ? value
        .replace(/([a-z])([A-Z])/g, "$1_$2")
        .replace(/\s+/g, "_")
        .toUpperCase()
    : value;

const normalizeColumnLabel = (value) =>
  value
    ? value
        .toString()
        .trim()
        .replace(/\s+/g, " ")
        .toLowerCase()
    : "";

export const resolveColumnType = (label, key = "") => {
  const source = normalizeColumnLabel(`${label || ""} ${key || ""}`);

  if (
    /price|cost|sell|levy|margin|weight|volume|cubic|quantity|count|hour|minute|delay_hours|delay hours/.test(
      source
    )
  ) {
    return "number";
  }

  if (
    /date|timestamp|eta|completed|despatch|dispatch|manifested|processed/.test(
      source
    )
  ) {
    return "date";
  }

  return "category";
};

const COLUMN_CATEGORY_BY_LABEL = {
  "despatch date": "Dates & Times",
  "carrier dispatch date": "Dates & Times",
  "reconciled dispatch date": "Dates & Times",
  "machship eta": "Dates & Times",
  "carrier eta": "Dates & Times",
  "carrier eta integration": "Dates & Times",
  "user updated eta": "Dates & Times",
  "reconciled eta": "Dates & Times",
  "machship completed date": "Dates & Times",
  "carrier completed date": "Dates & Times",
  "user updated completed date": "Dates & Times",
  "reconciled completed date": "Dates & Times",
  "original eta (local)": "Dates & Times",
  "revised eta": "Dates & Times",
  "revised completion date": "Dates & Times",
  "eta (local)": "Dates & Times",
  "date created": "Dates & Times",
  "completed date (local)": "Dates & Times",
  "manifested date": "Dates & Times",
  "manifesting timestamp (utc)": "Dates & Times",
  "desired despatch date (utc)": "Dates & Times",
  "difot original eta time": "Dates & Times",
  "difot eta time": "Dates & Times",
  user: "People & Entities",
  "processed by": "People & Entities",
  customer: "People & Entities",
  "child customer": "People & Entities",
  "parent customer": "People & Entities",
  carrier: "People & Entities",
  "carrier abbreviation": "People & Entities",
  "carrier display": "People & Entities",
  "carrier service abbreviation": "People & Entities",
  "carrier service display": "People & Entities",
  "carrier customer nk": "People & Entities",
  "from name": "People & Entities",
  "to name": "People & Entities",
  "from suburb": "Locations (Origin)",
  "from state": "Locations (Origin)",
  "from postcode": "Locations (Origin)",
  "from zone": "Locations (Origin)",
  "from zone (cora)": "Locations (Origin)",
  "from cora zone": "Locations (Origin)",
  "to suburb": "Locations (Destination)",
  "to state": "Locations (Destination)",
  "to postcode": "Locations (Destination)",
  "to zone": "Locations (Destination)",
  "to zone (cora)": "Locations (Destination)",
  "to cora zone": "Locations (Destination)",
  "machship number": "Shipment Details",
  "carrier number": "Shipment Details",
  service: "Shipment Details",
  "consignment count": "Shipment Details",
  items: "Shipment Details",
  "dg consignment": "Shipment Details",
  "special instructions": "Shipment Details",
  "metro / regional": "Shipment Details",
  "tracking status": "Status & Tracking",
  "management status": "Status & Tracking",
  completed: "Status & Tracking",
  returned: "Status & Tracking",
  reconciled: "Status & Tracking",
  "kpi hit": "Status & Tracking",
  "kpi measure": "Status & Tracking",
  "kpi measure (old)": "Status & Tracking",
  "kpi explanation": "Status & Tracking",
  "has attachment": "Status & Tracking",
  processed: "Status & Tracking",
  "process steps": "Status & Tracking",
  "eta affected by public holidays": "Status & Tracking",
  "total quantity": "Dimensions & Weight",
  "total cubic volume (m³)": "Dimensions & Weight",
  "total cubic volume (m3)": "Dimensions & Weight",
  "total weight (kg)": "Dimensions & Weight",
  "max item height (cm)": "Dimensions & Weight",
  "max item length (cm)": "Dimensions & Weight",
  "max item width (cm)": "Dimensions & Weight",
  "base cost price": "Costs & Pricing",
  "cost fuel levy": "Costs & Pricing",
  "base sell price": "Costs & Pricing",
  "sell fuel levy": "Costs & Pricing",
  "mcshp base cost": "Costs & Pricing",
  "mcshp fuel cost": "Costs & Pricing",
  "mcshp net cost (ex tax)": "Costs & Pricing",
  "mcshp tax cost": "Costs & Pricing",
  "mcshp total cost (inc tax)": "Costs & Pricing",
  "mcshp base charge": "Costs & Pricing",
  "mcshp fuel charge": "Costs & Pricing",
  "mcshp net charge (ex tax)": "Costs & Pricing",
  "mcshp tax charge": "Costs & Pricing",
  "mcshp total charge (inc tax)": "Costs & Pricing",
  "reconciled base cost": "Costs & Pricing",
  "reconciled fuel cost": "Costs & Pricing",
  "reconciled net cost (ex tax)": "Costs & Pricing",
  "reconciled tax cost": "Costs & Pricing",
  "reconciled total cost (inc tax)": "Costs & Pricing",
  "reconciled base charge": "Costs & Pricing",
  "reconciled fuel charge": "Costs & Pricing",
  "reconciled net charge (ex tax)": "Costs & Pricing",
  "reconciled tax charge": "Costs & Pricing",
  "reconciled total charge (inc tax)": "Costs & Pricing",
  "customer reference": "References",
  "customer reference 2": "References",
};

export const resolveColumnCategory = (label) =>
  COLUMN_CATEGORY_BY_LABEL[normalizeColumnLabel(label)] || "Other";

export const resolveColumnUnit = (label, key = "") => {
  const source = normalizeColumnLabel(`${label || ""} ${key || ""}`);

  if (
    /price|cost|sell|levy|margin|revenue|charge|amount|profit/.test(source)
  ) {
    return "$";
  }

  if (/weight|kg|kilogram/.test(source)) {
    return "kg";
  }

  if (/cubic|volume|m3|m³|cbm/.test(source)) {
    return "m3";
  }

  if (/height|length|width|cm|centimet/.test(source)) {
    return "cm";
  }

  if (/quantity|count|items|consignment/.test(source)) {
    return "count";
  }

  if (/hour|hours/.test(source)) {
    return "hours";
  }

  if (/minute|minutes/.test(source)) {
    return "minutes";
  }

  return null;
};

export const resolveColumnMeta = (column) => {
  if (!column) {
    return null;
  }
  const lower = column.toLowerCase();
  const camel = lower.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
  const meta =
    LEGACY_COLUMN_TYPES[column] ||
    LEGACY_COLUMN_TYPES[lower] ||
    LEGACY_COLUMN_TYPES[camel];
  return {
    key: column,
    label: meta?.label || column,
    type: meta?.type || resolveColumnType(meta?.label || column, column),
    unit: meta?.unit || resolveColumnUnit(meta?.label || column, column),
    category: resolveColumnCategory(meta?.label || column),
    normalizedKey: normalizeKey(column),
  };
};

export const buildTableRows = (rows, table) => {
  if (!rows?.length) {
    return [];
  }
  const columnKeys = table.columns.map((column) => column.key);
  const uniqueKey =
    table.name === "Customers"
      ? "customerNk"
      : table.name === "Carriers"
      ? "carrierAbbreviation"
      : null;
  const seen = new Set();

  return rows.reduce((acc, row) => {
    const record = {};
    let hasValue = false;

    columnKeys.forEach((key) => {
      const upperKey = key.toUpperCase();
      const lowerKey = key.toLowerCase();
      const snakeUpperKey = normalizeKey(key);
      const snakeLowerKey = snakeUpperKey?.toLowerCase();
      const value =
        row[key] !== undefined
          ? row[key]
          : row[upperKey] !== undefined
          ? row[upperKey]
          : row[snakeUpperKey] !== undefined
          ? row[snakeUpperKey]
          : row[snakeLowerKey] !== undefined
          ? row[snakeLowerKey]
          : row[lowerKey];
      if (value !== undefined) {
        record[key] = value;
        hasValue = true;
      }
    });

    if (!hasValue) {
      return acc;
    }

    if (uniqueKey) {
      const id = record[uniqueKey];
      if (id == null || seen.has(id)) {
        return acc;
      }
      seen.add(id);
    }

    acc.push(record);
    return acc;
  }, []);
};

export const applyVisualizationFilters = (rows) => {
  if (!rows?.length) {
    return [];
  }
  // Visualization Builder should ignore global customer/carrier filters.
  return rows;
};

export const groupedSeries = (rows, xKey, yKey, groupKey) => {
  const byGroup = new Map();
  rows.forEach((row) => {
    const groupValue = row[groupKey] ?? "Other";
    if (!byGroup.has(groupValue)) {
      byGroup.set(groupValue, []);
    }
    byGroup.get(groupValue).push(row);
  });

  const categories = Array.from(new Set(rows.map((row) => row[xKey])));

  const series = Array.from(byGroup.entries()).map(
    ([groupValue, groupRows]) => {
      const sums = categories.map((category) =>
        groupRows
          .filter((row) => row[xKey] === category)
          .reduce((acc, row) => acc + (row[yKey] ?? 0), 0)
      );
      return {
        name: groupValue,
        data: sums,
      };
    }
  );

  return { categories, series };
};

export const simpleSeries = (rows, xKey, yKey) => {
  const categories = Array.from(new Set(rows.map((row) => row[xKey])));
  const values = categories.map((category) =>
    rows
      .filter((row) => row[xKey] === category)
      .reduce((acc, row) => acc + (row[yKey] ?? 0), 0)
  );
  return { categories, values };
};

export const deriveOutlierThreshold = (rows, percentile = 90) => {
  const values = rows
    .map((row) => row?.reliabilityGap)
    .filter((value) => Number.isFinite(value))
    .sort((a, b) => a - b);

  if (!values.length) {
    return 0;
  }

  const clamped = Math.min(100, Math.max(0, percentile));
  const index = Math.min(
    values.length - 1,
    Math.floor((clamped / 100) * (values.length - 1))
  );
  return Number(values[index].toFixed(2));
};

export const CHART_TYPE_OPTIONS = [
  { value: "bar", label: "Bar" },
  { value: "line", label: "Line" },
  { value: "area", label: "Area" },
  { value: "pie", label: "Pie" },
  { value: "donut", label: "Donut" },
];

export const TOP_N_OPTIONS = [
  { value: "all", label: "All" },
  { value: 5, label: "Top 5" },
  { value: 10, label: "Top 10" },
  { value: 20, label: "Top 20" },
  { value: 50, label: "Top 50" },
];

export const SORT_OPTIONS = [
  { value: "desc", label: "Largest first" },
  { value: "asc", label: "Smallest first" },
];

export const ON_TIME_CHART_TYPE_OPTIONS = [
  { value: "bar", label: "Bar" },
  { value: "line", label: "Line" },
  { value: "area", label: "Area" },
];

export const VIZ_CHART_OPTIONS = [
  { value: "line", label: "Line" },
  { value: "area", label: "Area" },
  { value: "bar", label: "Bar" },
  { value: "column", label: "Column" },
  { value: "mixed", label: "Mixed" },
  { value: "rangeArea", label: "Range Area" },
  { value: "rangeBar", label: "Timeline / Range Bars" },
  { value: "funnel", label: "Funnel" },
  { value: "candlestick", label: "Candlestick" },
  { value: "boxPlot", label: "Box Plot" },
  { value: "bubble", label: "Bubble" },
  { value: "scatter", label: "Scatter" },
  { value: "heatmap", label: "Heatmap" },
  { value: "treemap", label: "Treemap" },
  { value: "slope", label: "Slope" },
  { value: "pie", label: "Pie" },
  { value: "radialBar", label: "Radial Bar" },
  { value: "radar", label: "Radar" },
  { value: "polarArea", label: "Polar Area" },
];
